import { BoxProps } from '@mui/material';

import {
  LayoutPanelContentContainerWrapper,
  LayoutPanelContentWrapper,
  LayoutPanelHeaderWrapper,
  LayoutPanelLeftSideBarWrapper,
  LayoutPanelRightSideBarWrapper,
  LayoutPanelWrapper,
} from './LayoutPanel.styled';

export interface ILayoutPanel extends BoxProps {
  width?: number | string;
  height?: number | string;
  padding?: string;
  showBorder?: boolean;
  children: React.ReactNode;
}

export interface ILayoutPanelHeader extends Omit<ILayoutPanel, 'width'> {
  showBottomBorder?: boolean;
  isSecondHeader?: boolean;
}

export interface ILayoutPanelContentContainer
  extends Omit<ILayoutPanel, 'width' | 'height'> {}

export interface ILayoutPanelLeftSideBar extends Omit<ILayoutPanel, 'height'> {
  showRightBorder?: boolean;
}

export interface ILayoutPanelRightSideBar
  extends Omit<ILayoutPanelLeftSideBar, 'showRightBorder'> {
  showLeftBorder?: boolean;
}

export interface ILayoutPanelContent
  extends Omit<ILayoutPanel, 'width' | 'height'> {}

export const LayoutPanel = (props: ILayoutPanel) => {
  const {
    width = '100%',
    height = '100%',
    padding = '8px 16px 0',
    showBorder = true,
    ...rest
  } = props;

  return (
    <LayoutPanelWrapper
      $width={width}
      $height={height}
      $padding={padding}
      $showBorder={showBorder}
      {...rest}>
      {props.children}
    </LayoutPanelWrapper>
  );
};

const Header = (props: ILayoutPanelHeader) => {
  const {
    height = 48,
    padding,
    showBottomBorder = true,
    isSecondHeader = false,
    ...rest
  } = props;

  return (
    <LayoutPanelHeaderWrapper
      $height={height}
      $padding={padding}
      $showBottomBorder={showBottomBorder}
      $isSecondHeader={isSecondHeader}
      {...rest}>
      {props.children}
    </LayoutPanelHeaderWrapper>
  );
};

const ContentContainer = (props: ILayoutPanelContentContainer) => {
  const { padding, ...rest } = props;

  return (
    <LayoutPanelContentContainerWrapper $padding={padding} {...rest}>
      {props.children}
    </LayoutPanelContentContainerWrapper>
  );
};

const LeftSideBar = (props: ILayoutPanelLeftSideBar) => {
  const { width = 320, padding, showRightBorder = true, ...rest } = props;

  return (
    <LayoutPanelLeftSideBarWrapper
      $width={width}
      $padding={padding}
      $showRightBorder={showRightBorder}
      {...rest}>
      {props.children}
    </LayoutPanelLeftSideBarWrapper>
  );
};

const RightSideBar = (props: ILayoutPanelRightSideBar) => {
  const { width = 320, padding, showLeftBorder = true, ...rest } = props;

  return (
    <LayoutPanelRightSideBarWrapper
      $width={width}
      $padding={padding}
      $showLeftBorder={showLeftBorder}
      {...rest}>
      {props.children}
    </LayoutPanelRightSideBarWrapper>
  );
};

const Content = (props: ILayoutPanelContent) => {
  const { padding, ...rest } = props;

  return (
    <LayoutPanelContentWrapper $padding={padding} {...rest}>
      {props.children}
    </LayoutPanelContentWrapper>
  );
};

export { Content, ContentContainer, Header, LeftSideBar, RightSideBar };

export default LayoutPanel;
